import React, { useEffect } from "react";
import { CardItem } from "../components/CartItem";

const datas = [
  {
    id: 1,
    name: "Mango",
    price: 220,
    quantity: 1,
    discount: 20,
  },
  {
    id: 2,
    name: "Apple",
    price: 99,
    quantity: 1,
    discount: 0,
  },
];

const CartPage = () => {
  const CalculateBagTotal = () => {
    let bagTotal = 0;
    let maxDiscount = 0;
    datas.forEach((item) => {
      bagTotal += item.price * item.quantity;
      if (item.discount > maxDiscount) {
        maxDiscount = item.discount;
      }
    });
    console.log("bagTotal", bagTotal, "maxDiscount", maxDiscount);
    return { bagTotal, maxDiscount };
  };

  useEffect(() => {
    CalculateBagTotal();
    document.title = "Cart";
  }, []);

  return (
    <div className="container mx-auto mt-[64px]">
      <div className="mb-16">
        <div className="px-5 py-4 mb-4 bg-white">
          <h3 className="mb-3 font-semibold">Order Details</h3>

          {datas.map((item) => (
            <CardItem key={item.id} item={item} />
          ))}
        </div>
        <div className="px-5 py-4 mb-4 bg-white">
          <section className="order-detail pt-0">
            <h3 className="mb-3 font-semibold">Order Details</h3>

            <ul className="text-gray-600 text-sm">
              <li className="flex justify-between py-1">
                <span>Bag total</span>
                <span>{(330).toFixed(2)}</span>
              </li>

              <li className="flex justify-between py-1 text-gray-400">
                <span>Bag savings</span>
                {/* {maxDiscount && (
                  <span className="text-gray-400">-30%</span>
                )} */}
              </li>

              <li className="flex justify-between py-1">
                <span>Coupon Discount</span>
                <a href="offer.html" className="text-red-500">
                  Apply Coupon
                </a>
              </li>

              <li className="flex justify-between pt-1 pb-2">
                <span>Delivery</span>
                <span>$50.00</span>
              </li>
              <li className="flex justify-between py-2 text-black font-semibold border-t">
                <span>Total Amount</span>
                <span>{(330 + 50).toFixed(2)}</span>
              </li>
            </ul>
          </section>
          <button className="w-full bg-teal-700 text-white p-2 rounded-md my-3 text-md font-semibold">
            Proceed to Checkout
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
